// import React from 'react';
// import './pagination.css';

// const Pagination = ({ currentPage, totalPages, onPageChange }) => {
//   const getPageNumbers = () => {
//     const pages = [];
//     for (let num = 1; num <= totalPages; num++) {
//       if (
//         num === 1 ||
//         num === totalPages ||
//         (num >= currentPage - 2 && num <= currentPage + 2)
//       ) {
//         pages.push(num);
//       } else if (
//         num === currentPage - 3 ||
//         num === currentPage + 3
//       ) {
//         pages.push('...');
//       }
//     }
//     return [...new Set(pages)];
//   };

//   const handleClick = (page) => {
//     if (page !== '...') onPageChange(page);
//   };

//   return (
//     totalPages > 1 && (
//       <div className="pagination d-flex jc-sb ai-center" id="pagination-container">
//         {/* Previous */}
//         {currentPage > 1 ? (
//           <button
//             className="pagination-prev common-text fts-15 black d-flex ai-center gap-5"
//             onClick={() => onPageChange(currentPage - 1)}
//           >
//             <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//               <path
//                 d="M15.8334 10.0001H4.16675M4.16675 10.0001L10.0001 15.8334M4.16675 10.0001L10.0001 4.16675"
//                 stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
//               />
//             </svg>
//             Previous
//           </button>
//         ) : (
//           <span className="pagination-prev invisible common-text d-flex ai-center  gap-5">
//             <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//               <path
//                 d="M15.8334 10.0001H4.16675M4.16675 10.0001L10.0001 15.8334M4.16675 10.0001L10.0001 4.16675"
//                 stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
//               />
//             </svg>
//             Previous
//           </span>
//         )}

//         {/* Page Numbers */}
//         <div className="number-buttons d-flex ai-center gap-5 fts-14 common-text ftw-5">
//           {getPageNumbers().map((num, i) =>
//             num === '...' ? (
//               <button key={i}>...</button>
//             ) : (
//               <button
//                 key={i}
//                 className={num === currentPage ? 'active common-text' : ''}
//                 onClick={() => handleClick(num)}
//               >
//                 {num}
//               </button>
//             )
//           )}
//         </div>

//         {/* Next */}
//         {currentPage < totalPages ? (
//           <button
//             className="pagination-prev d-flex ai-center common-text fts-15 black gap-5"
//             onClick={() => onPageChange(currentPage + 1)}
//           >
//             Next
//             <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//               <path
//                 d="M4.1665 10.0001H15.8332M15.8332 10.0001L9.99984 4.16675M15.8332 10.0001L9.99984 15.8334"
//                 stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//         ) : (
//           <span className="pagination-prev invisible common-text d-flex ai-center gap-5">
//             Next
//             <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//               <path
//                 d="M4.1665 10.0001H15.8332M15.8332 10.0001L9.99984 4.16675M15.8332 10.0001L9.99984 15.8334"
//                 stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
//               />
//             </svg>
//           </span>
//         )}
//       </div>
//     )
//   );
// };

// export default Pagination;

import './pagination.css';

const Pagination = ({ currentPage, totalPages, onPageChange, totalCount, perPage }) => {
  const getPageNumbers = () => {
    const pages = [];
    
    // If totalPages is 7 or less, show all pages
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }
    
    // Always show first page
    pages.push(1);
    
    // Show ellipsis if current page is far from start
    if (currentPage > 4) {
      pages.push('...');
    }
    
    // Show pages around current page
    const startPage = Math.max(2, currentPage - 1);
    const endPage = Math.min(totalPages - 1, currentPage + 1);
    
    for (let i = startPage; i <= endPage; i++) {
      if (i !== 1 && i !== totalPages) {
        pages.push(i);
      }
    }
    
    // Show ellipsis if current page is far from end
    if (currentPage < totalPages - 3) {
      pages.push('...');
    }
    
    // Always show last page
    if (totalPages > 1) {
      pages.push(totalPages);
    }
    
    return pages;
  };

  const handleClick = (page) => {
    if (page !== '...' && page !== currentPage) {
      onPageChange(page);
    }
  };

  const startItem = ((currentPage - 1) * perPage) + 1;
  const endItem = Math.min(currentPage * perPage, totalCount);

  return (
    totalPages > 1 && (
      <div className="pagination-wrapper">
        <div className="pagination-info common-text fts-14">
          Showing {startItem} to {endItem} of {totalCount} results
        </div>
        <div className="pagination d-flex jc-sb ai-center" id="pagination-container">
          {/* Previous */}
          {currentPage > 1 ? (
            <button
              className="pagination-prev common-text fts-15 black d-flex ai-center gap-5"
              onClick={() => onPageChange(currentPage - 1)}
            >
              <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M15.8334 10.0001H4.16675M4.16675 10.0001L10.0001 15.8334M4.16675 10.0001L10.0001 4.16675"
                  stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
                />
              </svg>
              Previous
            </button>
          ) : (
            <span className="pagination-prev invisible common-text d-flex ai-center gap-5">
              <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M15.8334 10.0001H4.16675M4.16675 10.0001L10.0001 15.8334M4.16675 10.0001L10.0001 4.16675"
                  stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
                />
              </svg>
              Previous
            </span>
          )}

          {/* Page Numbers */}
          <div className="number-buttons d-flex ai-center gap-5 fts-12 common-text ftw-5">
            {getPageNumbers().map((num, i) =>
              num === '...' ? (
                <span key={i} className="pagination-ellipsis">...</span>
              ) : (
                <button
                  key={i}
                  className={num === currentPage ? 'active common-text fts-12' : ''}
                  onClick={() => handleClick(num)}
                >
                  {num}
                </button>
              )
            )}
          </div>

          {/* Next */}
          {currentPage < totalPages ? (
            <button
              className="pagination-prev d-flex ai-center common-text fts-15 black"
              onClick={() => onPageChange(currentPage + 1)}
            >
              Next
              <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M4.1665 10.0001H15.8332M15.8332 10.0001L9.99984 4.16675M15.8332 10.0001L9.99984 15.8334"
                  stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
                />
              </svg>
            </button>
          ) : (
            <span className="pagination-prev invisible common-text d-flex ai-center gap-5">
              Next
              <svg className="pagination-svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M4.1665 10.0001H15.8332M15.8332 10.0001L9.99984 4.16675M15.8332 10.0001L9.99984 15.8334"
                  stroke="#344054" strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round"
                />
              </svg>
            </span>
          )}
        </div>
      </div>
    )
  );
};

export default Pagination;